import api from './api';

export interface ContactLead {
    id: number;
    public_id: string;
    contact: string;
    created_at: string;
    status: 'new' | 'read' | 'closed';
    source?: string | null;
}

export interface ContactLeadCreate {
    contact: string;
    source?: string;
}

export interface ContactLeadResponse {
    success: boolean;
    message?: string;
    error?: string;
    data?: ContactLead;
    items?: ContactLead[];
    total?: number;
}

class ContactLeadService {
    async create(contactLead: ContactLeadCreate): Promise<ContactLeadResponse> {
        try {
            const response = await api.post<ContactLeadResponse>('/api/contacts/request/lead', contactLead);
            return response;
        } catch (error: any) {
            console.error('Error creating contact lead:', error);
            throw error;
        }
    }

    async getAll(status?: string): Promise<ContactLead[]> {
        try {
            const url = status ? `/api/contacts/request/lead?status=${status}` : '/api/contacts/request/lead';
            const response = await api.get<ContactLeadResponse>(url);
            return response.items || [];
        } catch (error: any) {
            console.error('Error fetching contact leads:', error);
            throw error;
        }
    }

    async getById(id: number): Promise<ContactLead> {
        try {
            const response = await api.get<ContactLeadResponse>(`/api/contacts/request/lead/${id}`);
            if (!response.data) {
                throw new Error('Contact lead not found');
            }
            return response.data;
        } catch (error: any) {
            console.error('Error fetching contact lead:', error);
            throw error;
        }
    }

    async updateStatus(id: number, status: 'new' | 'read' | 'closed'): Promise<ContactLeadResponse> {
        try {
            const response = await api.patch<ContactLeadResponse>(`/api/contacts/request/lead/${id}/status`, { status });
            return response;
        } catch (error: any) {
            console.error('Error updating contact lead status:', error);
            throw error;
        }
    }

    async delete(id: number): Promise<ContactLeadResponse> {
        try {
            const response = await api.delete<ContactLeadResponse>(`/api/contacts/request/lead/${id}`);
            return response;
        } catch (error: any) {
            console.error('Error deleting contact lead:', error);
            throw error;
        }
    }
}

export default new ContactLeadService();
